import { render } from "./Dashboard.vue?vue&type=template&id=425fd09c&lang=pug"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script